const getListKey = (listId) => `klaviyo_signed_${listId}`;

export const getStoredList = (listId) =>
  window.localStorage.getItem(getListKey(listId));

const storeSignupEvent = (listId) => {
  if (!getStoredList(listId)) {
    window.localStorage.setItem(getListKey(listId), "true");
  }
};

function getApiUrl() {
  const raw =
    window.newsletterApiUrl ||
    "https://zpwvnxkydvhlqenmpqng.supabase.co/functions/v1";
  return raw.replace(/\/+$/, "");
}

export async function subscribe(
  email,
  firstName,
  lastName,
  tag,
  listId,
  params = {},
) {
  const apiUrl = getApiUrl();
  if (!apiUrl) {
    console.error(
      "Newsletter API URL is not configured (window.newsletterApiUrl is missing)",
    );
    return { success: false, error: "Newsletter API URL is not configured" };
  }

  if (!listId) {
    console.error("Please provide a list id");
    return { success: false, error: "Please provide a list id" };
  }

  const body = {
    email,
    listId,
    ...(firstName && { firstName }),
    ...(lastName && { lastName }),
    ...(tag && { tag }),
    ...(params.phone && { phone: params.phone }),
    ...(params.dateOfBirth && { dateOfBirth: params.dateOfBirth }),
  };

  try {
    const res = await fetch(`${apiUrl}/subscribe`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

    const json = await res.json();

    if (json.success) {
      storeSignupEvent(listId);
    }

    return json;
  } catch (err) {
    console.error("Newsletter subscribe error:", err);
    return { success: false, error: "Network error. Please try again." };
  }
}

function validateEmail(email) {
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export default {
  subscribe,
  validateEmail,
};
